import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import Word from '../../../containers/Common/Word'

import * as constants from '../../../constants'
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { GameContext } from '../GameProvider'
import { useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'

const styles = theme => ({
  subheader: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: theme.palette.grey[700],
  },
  subheaderIcon: {
    marginRight: theme.spacing.unit,
  },
  cardContent: {
    paddingTop: 0,
  },
  menuItemTypography: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  textFieldWide: {
    width: '100%',
    maxWidth: 400 + theme.spacing.unit,
  },
  textField: {
    width: '100%',
    maxWidth: 200,
    textAlign: 'center',
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  formControl: {
    width: '100%',
    maxWidth: 200,
    textAlign: 'center',
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  input: {
    textAlign: 'center'
  },
  createRoomButton: {
  }
})

const NewGameSettingsDialog = (props) => {
  const { classes } = props

  var disabledCreateRoomButton

  const [title, setTitle] = useState('')
  const [gameType, setGameType] = useState(constants.gameType.LIVE_GAME)
  const [openingRule, setOpeningRule] = useState(constants.OPENING_RULE.FREE)
  const [minute, setMinute] = useState('5')
  const [increaseSecond, setIncreaseSecond] = useState('0')
  const [days, setDays] = useState('30')
  const [daysPerMove, setDaysPerMove] = useState('1')
  const [turn, setTurn] = useState(constants.TURN_SETTING.RANDOM)
  const [enableUndo, setEnableUndo] = useState(constants.UNDO_SETTING.OK)
  const [error, setError] = useState({
    title: false,
    minute: false,
    increaseSecond: false
  })

  const gameContext = useContext(GameContext)
  const { selectedGroup, openNewGameSettingsDialog, setOpenNewGameSettingsDialog } = gameContext

  disabledCreateRoomButton = error.title || error.minute || error.increaseSecond
  
  const handleChange = (name) => (event) => {
    var val, newError
    newError = { ...error }
    switch (name) {
      case 'title':
        newError.title = Boolean(event.target.value > 20)
        setTitle(event.target.value)
        break
      case 'openingRule':
        setOpeningRule(event.target.value)
        break
      case 'gameType':
        setGameType(event.target.value)
        break
      case 'minute': 
        val = parseInt(event.target.value, 10)
        newError.minute = Boolean(isNaN(val) || 1 > val || 60 < val)
        setMinute(event.target.value)
        break
      case 'increaseSecond':
        val = parseInt(event.target.value, 10)
        newError.increaseSecond = Boolean(isNaN(val) || 0 > val || 60 < val)
        setIncreaseSecond(event.target.value)
        break
      case 'days':
        setDays(event.target.value)
        break
      case 'daysPerMove':
        setDaysPerMove(event.target.value)
        break
      case 'turn':
        setTurn(event.target.value)
        break
      case 'enableUndo':
        setEnableUndo(event.target.value)
        break
      default:
        break
    }
    setError(newError)
  }
  
  return (
    <Dialog open={openNewGameSettingsDialog} onClose={() => setOpenNewGameSettingsDialog(false)}>
      <DialogTitle>
        <Word wid={WID.NEW_GAME_SETTINGS_CARD.CARD_TITLE}/>
      </DialogTitle>
      <DialogContent className={classes.cardContent}>
        <div>
          <TextField
            label={<Word wid={WID.NEW_GAME_SETTINGS_CARD.GAME_TITLE_LABEL}/>}
            value={title}
            onChange={handleChange('title')}
            className={classes.textFieldWide}
            margin='normal'
            error={error.title}
          />
        </div>
        <div>
          <TextField
            label={<Word wid={WID.NEW_GAME_SETTINGS_CARD.OPENING_RULE_LABEL}/>}
            select
            value={openingRule}
            onChange={handleChange('openingRule')}
            className={classes.textField}
            margin='normal'
          >
            {constants.openingRuleItems.filter(item => item.value !== constants.gameType.NONE).map(item => 
              <MenuItem key={item.value} value={item.value}>
                <Typography className={classes.menuItemTypography}>
                  <Word wid={item.wid}/>
                </Typography>
              </MenuItem>
            )}
          </TextField>
          <TextField
            label={<Word wid={WID.NEW_GAME_SETTINGS_CARD.GAME_TYPE}/>}
            select
            value={gameType}
            onChange={handleChange('gameType')}
            className={classes.textField}
            margin='normal'
          >
            {constants.gameTypeMenuItems.map(item =>
              <MenuItem key={item.value} value={item.value} disabled={item.value === constants.gameType.DAILY_GAME}>
                <Typography className={classes.menuItemTypography}>
                  <Word wid={item.wid}/>
                </Typography>
              </MenuItem>
            )}
          </TextField>
        </div>
        {gameType === constants.gameType.LIVE_GAME && (
          <div>
            <FormControl className={classes.formControl}>
              <InputLabel><Word wid={WID.NEW_GAME_SETTINGS_CARD.TIME}/></InputLabel>
              <Input
                value={minute}
                onChange={handleChange('minute')}
                type='number'
                endAdornment={<InputAdornment position="end"><Word wid={WID.NEW_GAME_SETTINGS_CARD.MINUTE}/></InputAdornment>}
                inputprops={{ textAlign: 'center' }}
                error={error.minute}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel><Word wid={WID.NEW_GAME_SETTINGS_CARD.TIME_INCREMENT}/></InputLabel>
              <Input
                value={increaseSecond}
                onChange={handleChange('increaseSecond')}
                type='number'
                endAdornment={<InputAdornment position="end"><Word wid={WID.NEW_GAME_SETTINGS_CARD.SECONDS}/></InputAdornment>}
                inputprops={{ textAlign: 'center' }}
                error={error.increaseSecond}
              />
            </FormControl>
          </div>
        )}
        {gameType === constants.gameType.DAILY_GAME && (
          <div>
            <FormControl className={classes.formControl}>
              <InputLabel><Word wid={WID.NEW_GAME_SETTINGS_CARD.TIME}/></InputLabel>
              <Input
                value={days}
                onChange={handleChange('days')}
                type='number'
                endAdornment={<InputAdornment position="end"><Word wid={WID.NEW_GAME_SETTINGS_CARD.DAYS}/></InputAdornment>}
                inputprops={{ textAlign: 'center' }}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel><Word wid={WID.NEW_GAME_SETTINGS_CARD.TIME_LIMITS_PER_MOVE}/></InputLabel>
              <Input
                value={daysPerMove}
                onChange={handleChange('daysPerMove')}
                type='number'
                endAdornment={<InputAdornment position="end"><Word wid={WID.NEW_GAME_SETTINGS_CARD.DAYS}/></InputAdornment>}
                inputprops={{ textAlign: 'center' }}
              />
            </FormControl>
          </div>
        )}
        <div>
          <TextField
            label={<Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TURN}/>}
            select
            value={turn}
            onChange={handleChange('turn')}
            className={classes.textField}
            margin='normal'
          >
            {constants.turnItems.filter(item => item.value !== constants.OPENING_RULE.NONE).map(item =>
              <MenuItem key={item.value} value={item.value}>
                <Typography>
                  <Word wid={item.wid}/>
                </Typography>
              </MenuItem>
            )}
          </TextField>
          <TextField
            label={<Word wid={WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.UNDO}/>}
            select
            value={enableUndo}
            onChange={handleChange('enableUndo')}
            className={classes.textField}
            margin='normal'
          >
            {constants.undoItems.map(item =>
              <MenuItem key={item.value} value={item.value}>
                <Typography>
                  <Word wid={item.wid}/>
                </Typography>
              </MenuItem>
            )}
          </TextField>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() =>setOpenNewGameSettingsDialog(false)}
          color='primary'
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            gameContext.createGameRoom({
              groupName: selectedGroup,
              title, gameType, openingRule,
              minute: parseInt(minute, 10),
              increaseSecond: parseInt(increaseSecond, 10),
              days: parseInt(days, 10),
              daysPerMove: parseInt(daysPerMove, 10),
              enableUndo: Boolean(parseInt(enableUndo, 10)),
              turnType: turn,
            })
            setOpenNewGameSettingsDialog(false)
          }
        }
          className={classes.createRoomButton}
          disabled={disabledCreateRoomButton}
        >
          <Word wid={WID.NEW_GAME_SETTINGS_CARD.MAKE_ROOM_BUTTON}/>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles, { withTheme: true })(NewGameSettingsDialog)



// WEBPACK FOOTER //
// ./src/Pages/Game/components/NewGameSettingsDialog.js